export function resolveBookingInvoiceNumber(booking, paymentHistory = []) {
  const fromBooking = String(booking?.invoice_number || '').trim();
  if (fromBooking) return fromBooking;

  const sources = [
    ...(Array.isArray(paymentHistory) ? paymentHistory : []),
    ...(Array.isArray(booking?.payments) ? booking.payments : []),
  ];
  if (sources.length === 0) return null;

  const sorted = [...sources].sort((a, b) => {
    const timeA = new Date(a.processed_at || a.payment_date || a.created_at || 0).getTime();
    const timeB = new Date(b.processed_at || b.payment_date || b.created_at || 0).getTime();
    return timeA - timeB;
  });

  for (const payment of sorted) {
    const invoiceNumber = String(payment?.invoice_number || '').trim();
    if (invoiceNumber) return invoiceNumber;
  }

  return null;
}
